import { pyAPI } from 'constants/api';
import fetchApi from 'services/fetch';
import { track, generateServerResponseError, globalTrackValues } from 'utils/segmenTracker';
import { SERVER_RESPONSE_FAILED, ACTIVATION, SERVER_RESPONSE_OK } from 'constants/segmentEvents';

const initialState = {
  lead: null,
  leadApiData: null,
  selectedDate: null,
  statusMessage: { message: null, shown: false },
  creditResponse: null,
};

export const sales = {
  state: { ...initialState },
  reducers: {
    updateCreditProfileData(state, payload) {
      return { ...state, creditResponse: payload };
    },
    updateLead(state, payload) {
      return { ...state, lead: payload };
    },
    updateLeadApiData(state, payload) {
      return { ...state, leadApiData: payload };
    },
    updateDate(state, payload) {
      return { ...state, selectedDate: payload };
    },
    showStatusMessage(state, payload) {
      return { ...state, statusMessage: { message: payload, shown: true } };
    },
    hideStatusMessage(state) {
      return { ...state, statusMessage: initialState.statusMessage };
    },
  },
  effects: (dispatch) => {
    return {
      async getCrditProfile(search) {
        dispatch.apiStatus.setProcessing(true);
        return fetchApi({
          method: 'POST',
          url: pyAPI.creditProfile,
          data: search,
        })
          .then((response) => {
            dispatch.apiStatus.setProcessing(false);
            this.updateCreditProfileData(response);
            track(SERVER_RESPONSE_OK, {
              journey: ACTIVATION,
              raw_response: [{ ...response?.data }],
              endpoint: pyAPI.creditProfile,
            });
            return Promise.resolve({ success: true, result: response?.data, responseCreditProfile: response });
          })
          .catch((error) => {
            dispatch.apiStatus.setProcessing(false);
            track(SERVER_RESPONSE_FAILED, {
              ...generateServerResponseError(
                error,
                ACTIVATION,
                globalTrackValues.PY.page_name,
                pyAPI.creditProfile,
                'Credit profile API',
                error.message
              ),
            });
            return Promise.resolve({ success: false });
          });
      },
    };
  },
};
